import React from 'react';
import css from './select-cart-addon-items-header.scss';
const SelectCartAddonItemsHeader = ({
  boxesCount,
  isEditMode,
  onBackClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: css.header
  }, /*#__PURE__*/React.createElement("span", {
    className: css.text
  }, /*#__PURE__*/React.createElement("span", null, "Want to add some of\xA0"), /*#__PURE__*/React.createElement("span", null, "our popular box add-ons?")), /*#__PURE__*/React.createElement("span", {
    className: css.boxesCount
  }, "(You are ordering ", boxesCount, " boxes)"), isEditMode ? /*#__PURE__*/React.createElement("span", {
    onClick: onBackClick,
    className: css.viewStepAtEditModeBtn
  }, "View Products") : null);
};
export default SelectCartAddonItemsHeader;